import { useEffect, useState } from "react";

const LOCATION_CHANGE_EVENT = "capone:locationchange";

let historyPatched = false;

const dispatchLocationChange = () => {
  window.dispatchEvent(new Event(LOCATION_CHANGE_EVENT));
};

const patchHistory = () => {
  if (historyPatched || typeof window === "undefined") {
    return;
  }

  historyPatched = true;

  const originalPushState = window.history.pushState;
  const originalReplaceState = window.history.replaceState;

  window.history.pushState = function (
    ...args: Parameters<History["pushState"]>
  ) {
    const result = originalPushState.apply(this, args);
    dispatchLocationChange();
    return result;
  };

  window.history.replaceState = function (
    ...args: Parameters<History["replaceState"]>
  ) {
    const result = originalReplaceState.apply(this, args);
    dispatchLocationChange();
    return result;
  };
};

export const usePathname = () => {
  const [pathname, setPathname] = useState(() =>
    typeof window === "undefined" ? "" : window.location.pathname
  );

  useEffect(() => {
    patchHistory();

    const handleLocationChange = () => {
      setPathname(window.location.pathname);
    };

    window.addEventListener("popstate", handleLocationChange);
    window.addEventListener(LOCATION_CHANGE_EVENT, handleLocationChange);

    return () => {
      window.removeEventListener("popstate", handleLocationChange);
      window.removeEventListener(LOCATION_CHANGE_EVENT, handleLocationChange);
    };
  }, []);

  return pathname;
};
